/*
 * Public API Surface of jk-life
 */

export * from './services/audio-record.service';


export * from './components/audio-recorder/audio-recorder.component';
export * from './components/emoji-selector/emoji-selector.component';
export * from './components/jk-calendar/jk-calendar-edit.component';
export * from './components/jk-calendar/jk-calendar.component';
export * from './components/mobilebarcode/mobilebarcode.component';
export * from './components/record-bar/record-bar.component';
export * from './components/rtsp/rtsp.component';
export * from './components/tea-timer/tea-timer.component';
export * from './components/tomato-timer/tomato-timer.component';
export * from './components/weather-widget/weather-widget.component';
export * from './components/webcam/webcam.component';
export * from './components/deepBreathing/deep-breathing-exerciser.component';
export * from './components/app-icon-generator/app-icon-generator';
export * from './components/google-news/google-news.component';

